import {rootRoute} from 'acng/core/config/routes';
angular
  .module('payment')

  .run([
    'PaymentBonus',
    '$injector',
    'onsOverlay',
    '$timeout',
    '$rootScope',
    'user',
    'sock',
    (PaymentBonus, $injector, onsOverlay, $timeout, $rootScope, user, sock) => {
      function livecamIsActive() {
        if (!$injector.has('Livecam')) {
          return false;
        }
        return $injector.get('Livecam').isActive();
      }

      let overlayShowed = false,
        timeout = null;

      async function overlay() {
        const showAdOverlay = (user.isInSplittyGroup(42, 1) || user.isInGroup('age18-25')) && !user.isPremium();
        const bonus = await PaymentBonus.get();
        timeout = null;
        if (!bonus && !showAdOverlay) {
          return;
        }
        if (!onsOverlay.count() && !livecamIsActive()) {
          if (showAdOverlay) {
            onsOverlay.create('adOverlay').open();
          } else {
            onsOverlay.create('bonusOverlay', {bonus}).open();
          }
          overlayShowed = true;
        } else {
          timeout = $timeout(overlay, 10000);
        }
      }

      $rootScope.$on('PaymentBonus', (_event, bonus) => {
        if (bonus && !timeout && !overlayShowed) {
          timeout = $timeout(overlay, 60000);
        }

        if (bonus?.expires()) {
          PaymentBonus.setExpireTimeout(bonus.expires_at);
        }
      });

      $rootScope.$on('userPool.login.success', () => {
        timeout = $timeout(overlay, 60000);
      });

      sock.registerHandler('bonus', data => {
        $rootScope.$broadcast('PaymentBonus', new PaymentBonus(data));
      });
    },
  ])

  .run([
    'PaymentBonus',
    'onsOverlay',
    'user',
    (PaymentBonus, onsOverlay, user) => {
      rootRoute.find('sedcardNav')?.addEventListener('enter', ev => {
        if (!(ev.detail.route.count % 5) && !user.isPremium() && !user.checkFirstLoginWithinDays(5)) {
          PaymentBonus.get().then(bonus => {
            if (!bonus) return;
            onsOverlay.create('bonusOverlay', {reason: 'payment.bonus.reason', bonus}).open();
          });
        }
      });
    },
  ])

  .run([
    'PaymentBonus',
    'sock',
    '$rootScope',
    (PaymentBonus, sock, $rootScope) => {
      sock.$on($rootScope, 'transaction', () => PaymentBonus.get());
    },
  ])

  .factory('PaymentBonus', [
    'ARCHIMEDES',
    'payment',
    'http',
    '$q',
    'Token',
    '$rootScope',
    '$timeout',
    'media',
    'sock',
    (ARCHIMEDES, payment, http, $q, Token, $rootScope, $timeout, media, sock) => {
      return class PaymentBonus {
        constructor(data) {
          this.name = data.name;
          this.type = data.type;
          this.value = data.value;
          this.unique = data.unique;
          this.trigger_type = data.trigger_type;
          this.expires_at = data.expires_at ? new Date(data.expires_at) : null;
        }

        expires() {
          return !!this.expires_at && this.trigger_type !== 'bonus_action';
        }

        hasExpired() {
          return this.expires() && this.expires_at <= Date.now();
        }

        click() {
          payment.overlay();
        }

        async getImageUrl(format) {
          //TODO: improve with next special
          // if (this.trigger_type == 'bonus_action') {
          //   return `${ASSET_PATH}${this.name}/payment/${format}_${locale.get()}.jpg`;
          // }
          const {default: getBonusBannerSrc} = await import(`${media.assets_ext}/bonus.js`);
          DEBUG: console.debug({name: this.name, format});
          DEBUG: console.debug(`${media.assets_ext}/${getBonusBannerSrc(this.name, format)}`);
          return `${media.assets_ext}/${getBonusBannerSrc(this.name, format)}`;
        }

        static bonusCall = null;
        static bonusTime = null;
        static expireTimeout = null;

        /**
         * @param {Date} expiresAt
         */
        static setExpireTimeout(expiresAt) {
          if (this.expireTimeout !== null) {
            $timeout.cancel(this.expireTimeout);
          }

          this.expireTimeout = $timeout(() => {
            $rootScope.$broadcast('PaymentBonus', null);
            $timeout(() => PaymentBonus.get(), 1000);
          }, Math.min(1000 * 3600 * 24, expiresAt - Date.now()));
        }

        static get() {
          if (!PaymentBonus.bonusCall || PaymentBonus.bonusTime < Date.now() - 3000) {
            $timeout.cancel(this.expireTimeout);
            PaymentBonus.bonusTime = Date.now();
            PaymentBonus.bonusCall = sock.connectPromise
              .then(() => payment.loadAndGetCustomerId())
              .then(() => Token.get())
              .then(token => {
                return (
                  http()
                    .get(ARCHIMEDES + '/customer/' + payment.customerId + '/bonus', {
                      headers: {
                        'X-AuthToken': token.getKey(),
                      },
                    })
                    .then(res => (!res.data || !res.data.value ? null : new PaymentBonus(res.data)))
                    //.then(() => new PaymentBonus({"name":"50percent","type":"percent","value":50,"unique":false,"expires_at":Date.now() + 200000}))
                    //.then(() => null)
                    .catch(err => {
                      if (!err.data || err.data.error != 1001) {
                        throw err;
                      }
                      return Token.renew().then(() => {
                        PaymentBonus.bonusTime = 0;
                        return PaymentBonus.get();
                      });
                    })
                    .then(bonus => {
                      $rootScope.$broadcast('PaymentBonus', bonus);
                      return bonus;
                    })
                );
              });
            return this.bonusCall;
          } else {
            return this.bonusCall.then(bonus => {
              if (bonus && bonus.hasExpired()) {
                this.bonusTime = 0;
                return $q.resolve(null);
              }
              $rootScope.$broadcast('PaymentBonus', bonus);
              return bonus;
            });
          }
        }
      };
    },
  ]);
